<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="store-head">
        <div class="back-link" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> {{ $t('LEADERBOARD') }} </div>
        </div>
      </div>
    </div>


    <div class="col-lg-12 mt-3">
      <div class="running-tournament-title">All Tournament</div>
    </div>
    <div class="row">

      <div class="d-flex gap-3 mb-4 justify-content-between" :class="active">
        <div class=" leaderboard-content d-flex col-sm-6 justify-content-center align-items-center"
             @click="makeActive('DAILY')"
             :style="active === 'DAILY' ? activeBackground : ''">
          {{ $t('DAILY') }}
        </div>
        <div class="leaderboard-content d-flex col-sm-6 align-items-center justify-content-center"
             @click="makeActive('MEGA')"
             :style="active === 'MEGA' ? activeBackground : ''">
          {{ $t('MEGA') }}
        </div>
      </div>

    </div>
    <div class="row mt-2" v-if="showRunningTournament">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4 mb-2" v-for="(tournament) in runningTournaments" :key="tournament.id">
            <div @click="getTournamentDetails(tournament.id)">
              <div class="tournament-card d-flex flex-column"
                   :style="{'background-image': `url(${tournament.img_background})`}" >
                <div class="tournament-content d-flex  justify-content-between">



                    <div class="default-img" style="margin-top:15px;">
                      <img :src="tournament.tournament_image" width="80" height="80" alt="default">
                    </div>

                  <div class="d-lex flex-column"  style="margin-right: 30px;">
                    <div class="tournament-title" >{{ tournament.name }}</div>

                      <div class="tournament-time-left" style="margin-top: 15px;">
                        <img src="@/assets/img/happy_img/clock.png" width="10" height="10" :alt="tournament.name">
                        Start Time:

                        {{ getDate(tournament.start_time) }}
                      </div>
                      <div class="tournament-time-left" >
                        <img src="@/assets/img/happy_img/clock.png" width="10" height="10" :alt="tournament.name">
                        End Time:

                        {{getDate(tournament.end_time ) }}
                      </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <DashboardFooterMenu/>
  </div>
</template>

<script>
import {sendRequest} from '@/http/axios.method';
import Loader from "@/views/components/Loader";
import DashboardFooterMenu from "@/views/components/DashboardFooterMenu";
import _ from "lodash";
import moment from 'moment';

export default {
  name: "LeaderBoard",
  components: {
    Loader,
    DashboardFooterMenu,
  },
  data() {
    return {
      loaderActive: false,
      arraySize: 4,
      counter: 0,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      showRunningTournament: false,
      runningTournaments: [],
      active: 'DAILY',
      activeBackground: {
        'background': '#08A8FF',
        'color': '#FFFFFF',
      },
    }
  },
  created() {
    this.getRunningTournaments();
  },
  methods: {
    getRunningTournaments() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament/running?type=' + this.active, {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.runningTournaments = response.data.tournaments;
              if (!_.isEmpty(this.runningTournaments)) {
                let image_number = 1;
                this.runningTournaments.forEach(tournament => {
                  let current_image = tournament.tournament_image.replace(process.env.VUE_APP_AWS_IMAGE_PATH, '');
                  tournament.tournament_image = ! _.isEmpty(current_image)? tournament.tournament_image : require('@/assets/img/happy_img/default_pic.png');
                  let current_image_number = image_number;
                  tournament.img_background = this.active === 'DAILY'
                      ? require('@/assets/img/happy_img/daily_' + image_number + '.png')
                      : require('@/assets/img/happy_img/mega_' + image_number + '.png');
                  image_number = image_number > 3 ? 1 : ++current_image_number;
                });
                this.showRunningTournament = true;
              }
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
     getDate(tournament_date) {

      return moment(tournament_date).format('YYYY-MM-DD');
     },
    getTournamentDetails(tournament_id) {
      this.$router.push({path: '/tournament-details', query: {tournament_id: tournament_id}})
    },
    makeActive(item) {
      if (this.active !== item) {
        this.active = item;
        this.getRunningTournaments();
      }

    }
  }
}
</script>

<style scoped>
li {
  style: none;
}

</style>
